<template>
    <div class="chart"></div>
</template>
<script>
import _ from 'lodash'
import * as d3 from 'd3'

var margin = { top: 20, right: 35, bottom: 40, left: 50 };

var width = 820 - margin.left - margin.right,
    height = 480 - margin.top - margin.bottom;

var x = d3.scaleLinear()
    .range([0, width]);

var y = d3.scaleLinear()
    .range([height, 0]);

var line = d3.line()
    .x((d) => x(d.x))
    .y((d) => y(d.y))
    .curve(d3.curveStep);

var color = d3.scaleOrdinal(d3.schemeCategory10);

export default {
    props: {
        lines: {
            type: Array,
            require: true
        }
    },
    mounted: function() {
        var svg = d3.select(this.$el).append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        var xMin = d3.min(_.map(this.lines, (line) => {
            return d3.min(line.points, (d) => d.x);
        }));

        var xMax = d3.max(_.map(this.lines, (line) => {
            return d3.max(line.points, (d) => d.x);
        }));

        var yMin = d3.min(_.map(this.lines, (line) => {
            return d3.min(line.points, d => d.y);
        }));

        var yMax = d3.max(_.map(this.lines, (line) => {
            return d3.max(line.points, d => d.y);
        }));

        x.domain([xMin, xMax]);
        y.domain([yMin, yMax]);

        svg.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x));

        svg.append('g')
            .attr('class', 'axis axis--y')
            .call(d3.axisLeft(y))
            .append('text')
            .attr('class', 'axis-title')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            // .attr('dy', '.71em')
            .style('text-anchor', 'end')
            .text('Gold Advantage');

        for (var i = this.lines.length - 1; i >= 0; i--) {
            var lineData = this.lines[i];

            var lineGroup = svg.append('g').attr('class', 'line-group');

            lineGroup.append('path')
                .datum(lineData.points)
                .attr('class', 'line')
                .attr('d', line)
                .style('stroke', color(i));

            var lastPoint = lineData.points[lineData.points.length - 1];

            lineGroup.append('text')
                .attr('y', y(lastPoint.y) + 5)
                .attr('x', width + 3)
                .attr('class', 'line-label')
                .text(lineData.id);

        }
    }
}
</script>
<style>
.chart {
    margin: auto;
    overflow: scroll;
    text-align: center;
}

.axis {
    font: 10px sans-serif;
}

.axis path,
.axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
}

.line {
    fill: none;
    stroke: steelblue;
    stroke-width: 1.5px;
}

.line-label {
    font-size: 13px;
    cursor: pointer;
}

.line-group:hover .line {
    stroke-width: 3px;
}
</style>